module.exports = __webpack_public_path__ + "img/smart-sms.bc650698.png";